export default {
  setPaymentUrl(state, paymentUrl) {
    state.paymentUrl = paymentUrl;
  },
  setSuccessPaymentUrl(state, successPaymentUrl) {
    state.successPaymentUrl = successPaymentUrl;
  },
};
